import { Link } from 'react-router-dom';

const footerLinks = {
  plataforma: [
    { label: 'Estadísticas', path: '/estadisticas' },
    { label: 'Comparador', path: '/comparador' },
    { label: 'Ligas', path: '/ligas' },
    { label: 'Rankings', path: '/ranking' },
  ],
  comunidad: [
    { label: 'Foro', path: '/comunidad' },
    { label: 'Tipsters', path: '/ranking' },
    { label: 'Alertas', path: '/comparador' },
    { label: 'Mi Bankroll', path: '/perfil' },
  ],
  recursos: [
    { label: 'Guía del Apostador', path: '/guia' },
    { label: 'Blog', path: '/' },
    { label: 'Juego Responsable', path: '/juego-responsable' },
    { label: 'API Docs', path: '/' },
  ],
  legal: [
    { label: 'Términos', path: '/terminos' },
    { label: 'Privacidad', path: '/privacidad' },
    { label: 'Cookies', path: '/cookies' },
  ],
};

const socials = [
  { icon: 'ri-twitter-x-line', label: 'X', href: 'https://x.com/apuesta_mente' },
  { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://instagram.com/apuesta_mente' },
  { icon: 'ri-tiktok-line', label: 'TikTok', href: 'https://tiktok.com/@apuesta_mente' },
];

export default function Footer() {
  return (
    <footer className="bg-[#080a0f] border-t border-[#1e2028]">
      <div className="max-w-[1440px] mx-auto px-6 py-16">
        {/* Top section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          <div>
            <p className="text-[#6b7280] text-xs font-semibold uppercase tracking-widest mb-4">Plataforma</p>
            <ul className="space-y-3">
              {footerLinks.plataforma.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-[#a8b2c1] text-sm hover:text-[#00e87a] transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[#6b7280] text-xs font-semibold uppercase tracking-widest mb-4">Comunidad</p>
            <ul className="space-y-3">
              {footerLinks.comunidad.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-[#a8b2c1] text-sm hover:text-[#00e87a] transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[#6b7280] text-xs font-semibold uppercase tracking-widest mb-4">Recursos</p>
            <ul className="space-y-3">
              {footerLinks.recursos.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-[#a8b2c1] text-sm hover:text-[#00e87a] transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[#6b7280] text-xs font-semibold uppercase tracking-widest mb-4">Legal</p>
            <ul className="space-y-3">
              {footerLinks.legal.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-[#a8b2c1] text-sm hover:text-[#00e87a] transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-[#1e2028] pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <div className="flex items-center gap-4">
              <img
                src="https://storage.readdy-site.link/project_files/fb63bf06-0e48-4930-a6dd-45971086fa42/2303f7d2-fc6e-41fc-94be-8137f8672a38_Gemini_Generated_Image_ttooeyttooeyttoo-1.png?v=65c53162ba716b86e52e0cd98ba851d4"
                alt="Apuestamente"
                className="h-8 w-auto object-contain"
              />
              <a
                href="mailto:apuestamente@gmail.com"
                className="flex items-center gap-1.5 text-[#6b7280] hover:text-[#00e87a] transition-colors text-sm whitespace-nowrap"
              >
                <i className="ri-mail-line text-base"></i>
                <span>apuestamente@gmail.com</span>
              </a>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#00e87a]"></div>
              <span className="text-[#6b7280] text-xs">Plataforma verificada y segura · Licencias DGOJ</span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <p className="text-[#4b5563] text-xs">+18 · Apuesta con responsabilidad</p>
          </div>

          <div className="flex items-center gap-4">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#2a2d3a] text-[#6b7280] hover:text-[#00e87a] hover:border-[#00e87a] transition-all duration-200 cursor-pointer"
              >
                <i className={`${s.icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 text-center">
          <p className="text-[#3d4149] text-xs">
            © 2025 Apuestamente. Todos los derechos reservados. El juego puede crear adicción · 900 200 225 (FEJAR).
          </p>
        </div>

        {/* Oddspedia Attribution — required by Oddspedia Webmaster terms */}
        <div className="mt-8 pt-6 border-t border-[#1e2028] flex flex-col sm:flex-row items-center justify-center gap-5">
          <a
            href="https://oddspedia.com"
            target="_blank"
            rel="noopener"
            aria-label="Oddspedia"
            className="flex items-center gap-2 opacity-90 hover:opacity-100 transition-opacity"
          >
            <img
              src="https://widgets.oddspedia.com/images/logo-oddspedia-light.svg"
              alt="Oddspedia"
              width="130"
              height="30"
              style={{ display: 'block', width: '130px', height: '30px', visibility: 'visible', opacity: 1 }}
              loading="eager"
              decoding="sync"
            />
          </a>
          <span className="text-[#2a2d3a] text-sm hidden sm:block">|</span>
          <a
            href="https://oddspedia.com"
            target="_blank"
            rel="noopener"
            className="text-[#6b7280] hover:text-[#00b4f0] text-xs font-medium transition-colors whitespace-nowrap"
          >
            Powered by Oddspedia
          </a>
        </div>
      </div>
    </footer>
  );
}
